module.exports = __webpack_public_path__ + "img/jefe_almacen_01.349a0954.jpg";